import React, { useMemo } from 'react';
import { Box, Card, Typography } from '@mui/material';

/**
 * Simple placeholder page shown when the current route requires a hub/patient,
 * but the user cleared that requirement while staying on the same URL.
 */
const RequirementMissing = ({ requirement }) => {
  const message = useMemo(() => {
    if (requirement === 'patient') return 'This page requires a patient to be selected.';
    if (requirement === 'hub') return 'This page requires a hub to be selected.';
    return 'This page requires additional context.';
  }, [requirement]);

  const action = useMemo(() => {
    if (requirement === 'patient') return 'Select a patient from the top bar to continue.';
    if (requirement === 'hub') return 'Select a hub from the top bar to continue.';
    return 'Select the required context from the top bar to continue.';
  }, [requirement]);

  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ p: 2, maxWidth: 720 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Requirement missing
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {message}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {action}
        </Typography>
      </Card>
    </Box>
  );
};

export default RequirementMissing;
